export default __webpack_public_path__ + "img/ckFBtRBH.022364cd.svg";